import React from 'react';

interface IState {
  hasError: boolean;
}
class ErrorBoundary extends React.Component<{ children: React.ReactNode }, IState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.error('error:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 可以将错误信息上报到服务器
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h2>Oops, there is an error!</h2>
          <button type="button" onClick={() => this.setState({ hasError: false })}>
            Try again?
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
